import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { PropertyResponse } from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

interface UpdatePropertyInput {
	name?: string
	description?: string
	/** Whether the AI should rewrite the full description (ZPL-186). */
	improve?: boolean
}

/**
 * Owner-only property edit (ZPL-186). The PATCH returns the synchronously
 * persisted property; AI-derived fields (summaries, and the improved full)
 * arrive later via the `ai-response.processed` realtime event, which the
 * detail page uses to re-fetch.
 */
export function useUpdateProperty(propertyId: string) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (input: UpdatePropertyInput) =>
			apiFetch<PropertyResponse>(`/api/common/properties/${propertyId}`, {
				method: "PATCH",
				body: JSON.stringify(input),
			}),
		onSuccess: (res) => {
			queryClient.setQueryData(queryKeys.property(propertyId), res.property)
		},
	})
}
